/**
 * Date Helper to centralize format
 */
export class CustomDate {

  /**
   * Format a date to a string like yyyy-mm-dd hh:mm:ss
   * @param {number} date -in millisecond
   * @return {string} the formatted date
   */
  public static getFormatedDateFromNumber(date: number): string {
    const myDate = new Date(date);
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hour = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();

    return this.formatDate(year, month, day, hour, minutes, seconds);
  }

  /**
   *  Format today date to a string like yyyy-mm-dd hh:mm:ss
   * @return {string} the formatted date
   */
  public static getFormatedToday(): string {
    const myDate = new Date();
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hour = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();

    return this.formatDate(year, month, day, hour, minutes, seconds);
  }

  /**
   *  format a detailed set of number to a correct date
   *
   * @param {number} year - the year as number
   * @param {number} month - the month as number [1-12]
   * @param {number} day - the day as number
   * @param {number} hour - hours as number
   * @param {number} minutes - minutes as number
   * @param {number} seconds - seconds as number
   * @return {string}
   */
  private static formatDate(year: number, month: number, day: number, hour: number, minutes: number, seconds: number): string {
    return year + '-' +
      (month > 9 ? '' : '0') + month + '-' +
      (day > 9 ? ' ' : '0') + day + '_' +
      (hour > 9 ? '' : '0') + hour + '.' +
      (minutes > 9 ? '' : '0') + minutes + '.' +
      (seconds > 9 ? '' : '0') + seconds;
  }

  public static getDayStartFromDateForRequest(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }
  public static getDayEndFromDateForRequest(date: Date): Date {
    date.setHours(23, 59, 59, 999);
    return date;
  }
  public static format(myDate: Date): string {
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hour = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();

    return year + '-' +
      (month > 9 ? '' : '0') + month + '-' +
      (day > 9 ? ' ' : '0') + day + ' ' +
      (hour > 9 ? '' : '0') + hour + ':' +
      (minutes > 9 ? '' : '0') + minutes + ':' +
      (seconds > 9 ? '' : '0') + seconds;
  }
}
